import type { FullInformationForm, User } from '@/api/auth';
import {
  fieldsMap,
  LOCAL_STORAGE_USER_INFO_FORM_KEY,
  NamesSteps,
} from '@/helpers/auth';
import { getValuesFromLocalStorage } from '@/helpers/common';

export const createErrorObjects = (errorObject: Record<string, any>) => {
  const steps = Object.keys(fieldsMap);

  return Object.keys(errorObject).map((key) => ({
    field: `${steps.find((step) =>
      fieldsMap[step].find((field) => field === key)
    )}.${key}`,
    message: Object.values(errorObject[key]),
  }));
};

export const getUserInfoInitialValues = (user?: User) => {
  try {
    const {
      [NamesSteps.PERSONAL_INFORMATION]: {
        firstName: savedFirstName,
        lastName: savedLastName,
        dateOfBirth: savedDateOfBirth,
        mobilePhone: savedMobilePhone,
      },
      [NamesSteps.ADDRESS_INFORMATION]: {
        country: savedCountry,
        state: savedState,
        address: savedAddress,
        city: savedCity,
        postalCode: savedPostalCode,
      },
    } = getValuesFromLocalStorage(LOCAL_STORAGE_USER_INFO_FORM_KEY) || {
      [NamesSteps.PERSONAL_INFORMATION]: {},
      [NamesSteps.ADDRESS_INFORMATION]: {},
    };

    const {
      firstName,
      lastName,
      dateOfBirth,
      mobilePhone,

      country,
      state,
      address,
      city,
      postalCode,
    } = user || {};

    const [year, month, day] = dateOfBirth?.split('-') || [null, null, null];

    return {
      [NamesSteps.PERSONAL_INFORMATION]: {
        firstName: firstName || savedFirstName,
        lastName: lastName || savedLastName,
        dateOfBirth: {
          day: day || savedDateOfBirth?.day,
          month: month || savedDateOfBirth?.month,
          year: year || savedDateOfBirth?.year,
        },
        mobilePhone: {
          code: savedMobilePhone?.code,
          number: mobilePhone || savedMobilePhone?.number,
        },
      },
      [NamesSteps.ADDRESS_INFORMATION]: {
        country: country || savedCountry,
        state: state || savedState,
        address: address || savedAddress,
        city: city || savedCity,
        postalCode: postalCode || savedPostalCode,
      },
    } as FullInformationForm;
  } catch (error) {
    console.log(error);
  }
};

export interface IError {
  field: string;
  message: string;
}
